/**
 * Preços e assinaturas (a consola comercial, ADR-0018 §4a), em português.
 * As mesmas chaves de billing.fr.ts, a língua de referência.
 */
export const billingPt = {
  "billing.tabs.aria": "Preços e assinaturas",
  "billing.tab.prices": "Preços",
  "billing.tab.promos": "Promoções",
  "billing.tab.discounts": "Descontos",
  "billing.refreshFailed": "A lista não pôde ser atualizada: é mostrada como estava.",
  "billing.anyPlan": "Todos os planos",
  "billing.planWithInterval": "{name}, cobrado {interval}",
  "billing.interval.month": "ao mês",
  "billing.interval.year": "ao ano",
  "billing.window": "de {from} a {to}",
  "billing.window.endedEarly": "parada em {date}",
  "billing.periods.whileSubscribed": "enquanto mantiver a assinatura",
  "billing.periods.count": "{count} períodos pagos",
  "billing.state.scheduled": "Agendada",
  "billing.state.running": "A decorrer",
  "billing.state.finished": "Terminada",
  "billing.state.ended_early": "Parada antes do fim",
  "billing.scope.pro": "Um profissional",
  "billing.scope.country": "Um país",
  "billing.scope.category": "Um ofício",
  "billing.priceState.in_force": "Em vigor",
  "billing.priceState.scheduled": "Agendado",
  "billing.priceState.superseded": "Substituído",
  "billing.prices.intro":
    "Um preço novo só se aplica a assinaturas novas. O profissional mantém o preço com que assinou.",
  "billing.prices.loading": "A carregar os preços…",
  "billing.prices.loadFailed": "Não foi possível carregar os preços.",
  "billing.prices.empty": "Ainda não há preços definidos.",
  "billing.prices.unpriced": "Sem preço: {plans}. Ninguém se pode assinar.",
  "billing.prices.imported": "Do valor original do escalão",
  "billing.promos.intro":
    "Uma promoção baixa o preço de um plano num país, para quem assinar dentro da janela. O profissional recebe só o preço mais baixo: promoção e desconto não se somam.",
  "billing.promos.loading": "A carregar as promoções…",
  "billing.promos.loadFailed": "Não foi possível carregar as promoções.",
  "billing.promos.empty": "Sem promoções por agora.",
  "billing.discounts.intro":
    "Um desconto é uma percentagem para um profissional, um país ou um ofício. O profissional recebe só o preço mais baixo: desconto e promoção não se somam.",
  "billing.discounts.loading": "A carregar os descontos…",
  "billing.discounts.loadFailed": "Não foi possível carregar os descontos.",
  "billing.discounts.empty": "Sem descontos por agora.",
  "billing.col.name": "Nome",
  "billing.col.plan": "Plano",
  "billing.col.country": "País",
  "billing.col.currency": "Moeda",
  "billing.col.amount": "Valor",
  "billing.col.amountDue": "Ainda por pagar",
  "billing.col.promoPrice": "Preço da promoção",
  "billing.col.percentOff": "Desconto",
  "billing.col.periods": "Duração",
  "billing.col.window": "Janela",
  "billing.col.state": "Estado",
  "billing.col.status": "Estado do pagamento",
  "billing.col.subscribers": "Profissionais abrangidos",
  "billing.col.createdBy": "Criada por",
  "billing.col.setBy": "Definido por",
  "billing.col.reason": "Motivo",
  "billing.col.validFrom": "A partir de",
  "billing.col.who": "Para quem",
  "billing.col.actions": "Ações",
  "billing.col.date": "Data",
  "billing.col.period": "Período coberto",
  "billing.col.provider": "Fornecedor",
  "billing.col.eventKind": "Evento",
  "billing.col.via": "Recebido por",
  "billing.col.result": "Resultado",
  "billing.col.detail": "Detalhe",
  "billing.col.eventRef": "Referência do evento",
  "billing.action.setPrice": "Definir um preço",
  "billing.action.newPromo": "Nova promoção",
  "billing.action.newDiscount": "Novo desconto",
  "billing.action.endNow": "Terminar agora",
  "billing.action.endPromo": "Terminar a promoção",
  "billing.action.endDiscount": "Terminar o desconto",
  "billing.action.extendSubscription": "Prolongar",
  "billing.action.endSubscription": "Terminar a assinatura",
  "billing.dialog.setPrice.title": "Definir um preço",
  "billing.dialog.setPrice.body":
    "Este preço vai aplicar-se às assinaturas novas nesse país. Quem já assinou mantém o seu.",
  "billing.dialog.newPromo.title": "Nova promoção",
  "billing.dialog.newPromo.body":
    "O preço da promoção substitui o preço do país durante a janela. O profissional mantém-no enquanto assinar, até ao limite indicado.",
  "billing.dialog.newDiscount.title": "Novo desconto",
  "billing.dialog.newDiscount.body":
    "Escolha um só destinatário: um profissional, um país ou um ofício. O profissional recebe só o preço mais baixo: desconto e promoção não se somam.",
  "billing.dialog.endPromo.title": "Terminar a promoção {subject}",
  "billing.dialog.endPromo.body": "Mais ninguém a poderá aproveitar. Quem já a tem, mantém-na.",
  "billing.dialog.endDiscount.title": "Terminar o desconto {subject}",
  "billing.dialog.endDiscount.body": "Deixa de se aplicar a assinaturas novas. Quem já o tem, mantém-no.",
  "billing.dialog.extendSubscription.title": "Prolongar {subject}",
  "billing.dialog.extendSubscription.body":
    "Gesto comercial: o acesso vai até à data escolhida e uma suspensão é levantada. O preço do profissional não muda.",
  "billing.dialog.endSubscription.title": "Terminar a assinatura {subject}",
  "billing.dialog.endSubscription.body":
    "O acesso para já e o fornecedor recebe ordem para deixar de cobrar. Não há reembolso: conceda um crédito em Paiements se for devido.",
  "billing.field.plan": "Plano",
  "billing.field.pickPlan": "Escolher um plano",
  "billing.field.country": "País",
  "billing.field.countryHint": "Código de duas letras, por exemplo GN.",
  "billing.field.currency": "Moeda",
  "billing.field.currencyHint": "Código de três letras, por exemplo GNF.",
  "billing.field.amount": "Preço ({currency})",
  "billing.field.validFrom": "A partir de (opcional)",
  "billing.field.validFromHint": "Vazio: o preço aplica-se já. Nunca uma data passada.",
  "billing.field.name": "Nome",
  "billing.field.nameHint": "O que a equipa vê na lista, por exemplo «Lançamento Conacri».",
  "billing.field.startsAt": "Início",
  "billing.field.endsAt": "Fim",
  "billing.field.periods": "Número de períodos (opcional)",
  "billing.field.periodsHint": "Vazio: o profissional mantém o preço enquanto assinar.",
  "billing.field.scope": "Para quem",
  "billing.field.pro": "O profissional",
  "billing.field.category": "Ofício",
  "billing.field.pickCategory": "Escolher um ofício",
  "billing.field.percentOff": "Percentagem de desconto",
  "billing.field.paidThrough": "Prolongar até",
  "billing.field.paidThroughHint": "Uma data futura. O acesso vai até lá.",
  "billing.problem.reason": "Indique um motivo com pelo menos {min} caracteres.",
  "billing.problem.plan": "Escolha um plano.",
  "billing.problem.country": "Escreva um código de país de duas letras.",
  "billing.problem.currency": "Escreva um código de moeda de três letras.",
  "billing.problem.amount": "Escreva um valor acima de zero.",
  "billing.problem.validFrom": "Indique uma data de início válida.",
  "billing.problem.backdated": "Um preço não pode começar no passado.",
  "billing.problem.name": "Indique um nome com pelo menos {min} caracteres.",
  "billing.problem.window": "Indique um início e um fim.",
  "billing.problem.windowOrder": "O fim tem de vir depois do início.",
  "billing.problem.periods": "O número de períodos tem de ser um inteiro acima de zero.",
  "billing.problem.pro": "Escolha o profissional em causa.",
  "billing.problem.category": "Escolha um ofício.",
  "billing.problem.percentOff": "A percentagem tem de ser um inteiro entre 1 e 100.",
  "billing.problem.paidThrough": "Indique uma data de fim válida.",
  "billing.problem.paidThroughPast": "A data tem de ser futura.",
  "billing.outcome.price": "Preço registado: {amount}, a partir de {date}.",
  "billing.outcome.promoCreated": "Promoção «{name}» criada.",
  "billing.outcome.promoEnded": "Promoção «{name}» parada. Quem já a tem, mantém-na.",
  "billing.outcome.discountCreated": "Desconto «{name}» criado.",
  "billing.outcome.discountEnded": "Desconto «{name}» parado. Quem já o tem, mantém-no.",
  "billing.outcome.extended": "Assinatura prolongada até {date}.",
  "billing.outcome.subscriptionEnded": "Assinatura terminada. O acesso foi cortado e o fornecedor deixa de cobrar.",
  "billing.error.stale": "Isto mudou enquanto estava a ver. Recarregue, confirme e tente de novo.",
  "billing.error.refused":
    "Recusado: os seus papéis não incluem a funcionalidade necessária. Peça acesso a um responsável.",
  "billing.error.invalid": "Recusado: o que foi enviado já não serve. Recarregue e confirme.",
  "billing.error.outcomeUnknown":
    "Sem resposta do servidor: pode ter ficado registado. Tente de novo: o mesmo clique não é aplicado duas vezes.",
  "billing.refused.planNotPriced": "Recusado: esse plano ainda não tem preço nesse país. Defina-o primeiro.",
  "billing.refused.invalidAmount": "Recusado: o valor tem de ser acima de zero.",
  "billing.refused.backdated": "Recusado: um preço não pode começar no passado.",
  "billing.refused.priceVersionExists":
    "Recusado: já começa uma versão nesse momento para esse plano e país. Recarregue a lista.",
  "billing.refused.invalidWindow": "Recusado: a janela não é válida. O fim tem de vir depois do início.",
  "billing.refused.alreadyOver": "Recusado: isto já terminou. Recarregue a lista.",
  "billing.refused.idempotencyKeyRequired": "Recusado: o pedido seguiu sem a chave. Feche a janela e comece de novo.",
  "billing.subscription.pending": "Pendente",
  "billing.subscription.active": "Ativo",
  "billing.subscription.ending": "Sem renovação",
  "billing.subscription.suspended": "Suspenso",
  "billing.subscription.ended": "Terminado",
  "billing.endReason.renewal_cancelled": "Renovação cancelada pelo profissional",
  "billing.endReason.unpaid": "Renovação por pagar",
  "billing.endReason.checkout_abandoned": "Pagamento nunca concluído",
  "billing.endReason.replaced": "Substituído por outra assinatura",
  "billing.endReason.ended_by_staff": "Terminado pela equipa",
  "billing.endReason.ended_by_provider": "Terminado pelo fornecedor",
  "billing.event.payment_succeeded": "Pagamento com sucesso",
  "billing.event.payment_failed": "Pagamento falhado",
  "billing.event.subscription_ended": "Assinatura terminada",
  "billing.via.webhook": "Webhook do fornecedor",
  "billing.via.poll": "Consultado por Walliyo",
  "billing.via.return": "Regresso à aplicação",
  "billing.via.reconcile": "Reconciliação",
  "billing.result.applied": "Aplicado",
  "billing.result.conflict": "Conflito",
  "billing.result.ignored": "Ignorado",
  "billing.priceInsteadOf": "{now} em vez de {regular}",
  "billing.reductionWithPeriods": "{name} · faltam {count} períodos",
  "billing.sub.loading": "A carregar a assinatura…",
  "billing.sub.loadFailed": "Não foi possível carregar a assinatura.",
  "billing.sub.none": "Este profissional nunca assinou.",
  "billing.sub.credit": "Crédito",
  "billing.sub.noCredit": "Nenhum",
  "billing.sub.noRefunds":
    "Não há reembolso numa assinatura. Um gesto é um crédito, concedido em Paiements, descontado no pagamento seguinte.",
  "billing.sub.creditLink": "Os seus pagamentos, para conceder um crédito →",
  "billing.sub.discountLink": "Dar um desconto a este profissional →",
  "billing.sub.since": "Aberta em {date}",
  "billing.sub.versionTitle": "A versão da assinatura mostrada: cada escrita envia-a.",
  "billing.sub.entitled": "Acesso aberto",
  "billing.sub.notEntitled": "Sem acesso",
  "billing.sub.provider": "Fornecedor",
  "billing.sub.renewsAutomatically": "renova automaticamente",
  "billing.sub.paidByHand": "pago à mão pelo profissional",
  "billing.sub.country": "País",
  "billing.sub.price": "Preço atual",
  "billing.sub.reduction": "Redução",
  "billing.sub.nextPlan": "Mudança de plano",
  "billing.sub.nextPlanValue": "muda para {plan} no fim do período",
  "billing.sub.paidThrough": "Pago até",
  "billing.sub.renewalCancelled": "Renovação cancelada em",
  "billing.sub.graceEnds": "Prazo de tolerância até",
  "billing.sub.ended": "Terminada em",
  "billing.sub.endReason": "Motivo do fim",
  "billing.sub.payments": "Pagamentos",
  "billing.sub.noPayments": "Sem pagamentos nesta assinatura.",
  "billing.sub.noPeriod": "Ainda sem cobertura",
  "billing.sub.events": "Eventos do fornecedor",
  "billing.sub.noEvents": "Sem eventos do fornecedor.",
  "billing.sub.actions": "Agir sobre esta assinatura",
  "billing.sub.actionsFoot":
    "Prolongar é um gesto, terminar é uma sanção. Ambos pedem um motivo e vão para o registo de auditoria.",
} as const;
